export default "__VITE_ASSET__BWjrSD0J__"